/* Costify mobile — bottom sheets, wishlist, qty steppers. Active on all viewports; harmless on desktop (shell hidden). */
(function () {
  'use strict';

  /* ---------- Bottom sheets ---------- */
  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    /* close any other sheet that's already open (only one at a time) */
    document.querySelectorAll('.cm-sheet.is-open').forEach(function (o) { if (o !== sheet) closeSheet(o); });
    /* full-screen sheets: anchor the top just below the fixed app header so it
       never clips the menu (header height differs between pages) */
    if (sheet.classList.contains('cm-sheet-full')) {
      var hdr = document.querySelector('.cm-topbar, .cm-tabhead');
      var hb = hdr ? hdr.getBoundingClientRect().bottom : 0;
      sheet.style.top = (Math.max(0, Math.round(hb)) + 8) + 'px';
    }
    var backdrop = document.querySelector('.cm-sheet-backdrop[data-for="' + id + '"]');
    if (backdrop) backdrop.classList.add('is-open');
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    var backdrop = document.querySelector('.cm-sheet-backdrop[data-for="' + sheet.id + '"]');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cm-open]');
    if (opener) { e.preventDefault(); openSheet(opener.getAttribute('data-cm-open')); return; }
    var closer = e.target.closest('[data-cm-close]');
    if (closer) { e.preventDefault(); closeSheet(closer.closest('.cm-sheet')); return; }
    var backdrop = e.target.closest('.cm-sheet-backdrop');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      var s = document.getElementById(backdrop.getAttribute('data-for'));
      if (s) s.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Drag-down-to-dismiss (swipe the sheet / handle down to close) ---------- */
  (function () {
    var CLOSE_AT = 88;               /* px dragged down before it dismisses */
    var active = null, startY = 0, dy = 0;
    document.addEventListener('touchstart', function (e) {
      var sheet = e.target.closest('.cm-sheet.is-open');
      if (!sheet) { active = null; return; }
      var onHandle = e.target.closest('.cm-sheet-head, .cm-sheet-grab');
      var body = sheet.querySelector('.cm-sheet-body');
      var atTop = !body || body.scrollTop <= 0;
      if (!onHandle && !atTop) { active = null; return; }   /* let the body scroll */
      active = sheet; startY = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!active) return;
      dy = e.touches[0].clientY - startY;
      if (dy <= 0) {                                          /* dragging up → normal scroll */
        if (active.classList.contains('is-dragging')) { active.classList.remove('is-dragging'); active.style.transform = ''; }
        return;
      }
      active.classList.add('is-dragging');
      active.style.transform = 'translateY(' + dy + 'px)';
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    function end() {
      if (!active) return;
      var sheet = active; active = null;
      sheet.classList.remove('is-dragging');
      sheet.style.transform = '';
      if (dy > CLOSE_AT) closeSheet(sheet);
      dy = 0;
    }
    document.addEventListener('touchend', end);
    document.addEventListener('touchcancel', end);
  })();

  /* ---------- Wishlist (localStorage) ---------- */
  var KEY = 'cm_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paintHearts() {
    var w = getWish();
    document.querySelectorAll('[data-cm-wish]').forEach(function (b) {
      b.classList.toggle('is-on', w.indexOf(b.getAttribute('data-cm-wish')) !== -1);
    });
    document.querySelectorAll('[data-cm-wishcount]').forEach(function (el) {
      el.textContent = w.length;
    });
  }
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-cm-wish]');
    if (!heart) return;
    e.preventDefault(); e.stopPropagation();
    var id = heart.getAttribute('data-cm-wish');
    var w = getWish(); var i = w.indexOf(id);
    if (i === -1) w.push(id); else w.splice(i, 1);
    setWish(w); paintHearts();
  });
  document.addEventListener('DOMContentLoaded', paintHearts);
  paintHearts();
})();
